<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
            
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">
                            <cariaracomp tabindex="1" v-bind:etiket="$t('Select-Current-Account')" v-bind:value="MusteriPersonel.Cari.Kod" v-bind:renk="color" :loading="loading" 
                                  v-model="MusteriPersonel.Cari.Kod"></cariaracomp>

                      </div>
                      <div class="flex md6">
                        <div v-show="codegorunum === true ">
                          <v-text-field :label="this.$t('Company-Code')" tabindex="2" :color="color" hide-details=""
                            v-model="MusteriPersonel.SirketAdi" :error-messages="errors.collect('bankakod')"
                            v-validate="'required'" data-vv-name="bankakod" required>
                          </v-text-field>
                        </div>

                        <v-text-field :label="$t('Expense-Center')" :color="color" tabindex="3" hide-details=""
                          v-model="MusteriPersonel.MasrafYeri" :error-messages="errors.collect('bankaadi')"
                          v-validate="'required'" data-vv-name="bankaadi" required>
                        </v-text-field>
                        <v-text-field :label="$t('Registry-No')" hide-details="" v-model="MusteriPersonel.SicilNo" :color="color">
                        </v-text-field>
                        <v-text-field :label="$t('Name_label')" hide-details="" :color="color" v-model="MusteriPersonel.Adi">
                        </v-text-field>
                        <v-text-field :label="$t('Surname_label')" hide-details="" v-model="MusteriPersonel.Soyadi" :color="color">
                        </v-text-field>
                        <v-text-field :label="$t('Workplace')" hide-details="" v-model="MusteriPersonel.CalismaYeri"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('Department')" hide-details="" v-model="MusteriPersonel.Bolum" :color="color">
                        </v-text-field>
                      </div>

                      <div class="flex md6" style="padding-left:2px;">
                        <v-text-field :label="$t('Domestic-Travel')" hide-details="" v-model="MusteriPersonel.IcSeyahat"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('International-Travel')" hide-details="" v-model="MusteriPersonel.DisSeyahat"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('Business-Area')" hide-details="" :color="color" v-model="MusteriPersonel.IsAlani">
                        </v-text-field>
                        <v-text-field :label="$t('Order')" hide-details="" :color="color" v-model="MusteriPersonel.Siparis">
                        </v-text-field>
                        <v-text-field :label="$t('Email_label')" hide-details="" :color="color" v-model="MusteriPersonel.Email">
                        </v-text-field>
                        <v-text-field :label="$t('Telephone')" hide-details="" :color="color" v-model="MusteriPersonel.Tel">
                        </v-text-field>
                      </div>

                      <div class="flex md12">

                        <v-checkbox disabled="" :label="$t('Customer-Staff-Open')" v-model="MusteriPersonel.KapatAc">
                        </v-checkbox>

                      </div>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">




              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="musteriackapa()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Client-Personnel-Turn-on-and-off') }} </span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update"> {{ $t('Client-Personnel-Turn-on-and-off') }} </span>
              </v-tooltip>


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>



            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>



            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title class="baslikfont">{{ $t('Customer-Personnel-Information') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>




              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t('Add-Customer-Personnel')}}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t('Add-Customer-Personnel')}}</span>
              </v-tooltip>





      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

<template slot="items" slot-scope="props">
  <tr
    :class="{ 'disabled-row': props.item.KapatAc === true }"
    :style="{ opacity: props.item.KapatAc ? 0.5 : 1, pointerEvents: props.item.KapatAc ? 'none' : 'auto' }"
    @click="props.item.KapatAc ? null : Getir(props.item.ID)"
  >
    <td class="text-xs-left">{{ props.item.ID }}</td>
    <td class="text-xs-left">{{ props.item.SirketAdi }}</td>
    <td class="text-xs-left">{{ props.item.MasrafYeri }}</td>
    <td class="text-xs-left">{{ props.item.SicilNo }}</td>
    <td class="text-xs-left">{{ props.item.Adi }}</td>
    <td class="text-xs-left">{{ props.item.Soyadi }}</td>
    <td class="text-xs-left">{{ props.item.CalismaYeri }}</td>
    <td class="text-xs-left">{{ props.item.Bolum }}</td>
  </tr>
</template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'ID',
            value: 'ID'
          },

          {
            text: this.$t('Company-Name'),
            value: 'SirketAdi'
          },
          {
            text: this.$t('Expense-Center'),
            value: 'MasrafYeri'
          },
          {
            text: this.$t('Registry-No'),
            value: 'SicilNo'
          },
          {
            text: this.$t('Name_label'),
            value: 'Adi'
          },
          {
            text: this.$t('Surname_label'),
            value: 'Soyadi'
          },
          {
            text: this.$t('Workplace'),
            value: 'CalismaYeri'
          },
          {
            text: this.$t('Department'),
            value: 'Bolum'
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,

        MusteriPersonel: {
          ID: '',
          SirketKodu: '',
          SirketAdi: '',
          MasrafYeri: '',
          SicilNo: '',
          Adi: '',
          Soyadi: '',
          CalismaYeri: '',
          Bolum: '',
          IcSeyahat: '',
          DisSeyahat: '',
          IsAlani: '',
          Siparis: '',
          Cari: {
            Kod: ''
          },
          KapatAc: false,
          Email: '',
          Tel: '',
        },




        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      //this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          SirketKodu: credentials.SirketKodu,
          CariKod: this.$route.params.code,
          KapatAc: true
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Müşteri Personel Bilgileri Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          CustomerPersonnelID: v

        }
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var seciliitems = [{
            autoText: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
            unvan1: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
            id: response.body.Cari.Kod
          }]
          this.state = seciliitems
          this.MusteriPersonel.Cari.Kod = response.body.Cari.Kod



          this.MusteriPersonel = response.body

        })
      },
      musteriackapa: musteriackapa,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      cariaracomp
    },
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu,
          CariKod: this.$route.params.code
        }

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu

        var params = this.MusteriPersonel

        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
                CariKod: this.$route.params.code,
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true

              setTimeout(() => {
               window.location.reload();
                }, 500); 
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }

  function ekle() {

    this.MusteriPersonel.ID = ''
    this.MusteriPersonel.SirketKodu = ''
    this.MusteriPersonel.SirketAdi = ''
    this.MusteriPersonel.MasrafYeri = ''
    this.MusteriPersonel.SicilNo = ''
    this.MusteriPersonel.Adi = ''
    this.MusteriPersonel.Soyadi = ''
    this.MusteriPersonel.CalismaYeri = ''
    this.MusteriPersonel.Bolum = ''
    this.MusteriPersonel.IcSeyahat = ''
    this.MusteriPersonel.DisSeyahat = ''
    this.MusteriPersonel.IsAlani = ''
    this.MusteriPersonel.Siparis = ''
    this.MusteriPersonel.Cari.Kod = this.$route.params.code
    this.MusteriPersonel.KapatAc = false
    this.MusteriPersonel.Email = ''
    this.MusteriPersonel.Tel = ''

    this.dialog = true
    this.dialog_baslik = this.$t('Customer-Personnel')
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function musteriackapa() {
    if (window.confirm('Müşter/Personel\'i açmak veya kapatmak istediğinize eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.MusteriPersonel.SirketKodu = credentials.SirketKodu
      var params = {
        CustomerPersonnelID: this.MusteriPersonel.ID,
        CloseOpen: !(this.MusteriPersonel.KapatAc)
      }



      this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelCloseOpen', params, {
        CariKod: this.$route.params.code,
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
        
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          var params1 = {
            SirketKodu: credentials.SirketKodu,
            CariKod: this.$route.params.code
          }
          this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
            CariKod: this.$route.params.code,
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false

setTimeout(() => {
               window.location.reload();
                }, 500); 
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
  this.$validator.validateAll().then((result) => {
    if (!result) return;

    const credentials = JSON.parse(localStorage.getItem("credentials"));
    const eskiID = this.MusteriPersonel.ID;

    
    this.$http.post(auth.API_URL + "api/Extra/CustomerPersonnelCloseOpen", {
      CustomerPersonnelID: eskiID,
      CloseOpen: true,
    }, {
      headers: { Authorization: "Bearer " + auth.getAuthHeader() },
    }).then(() => {
      
      this.MusteriPersonel.ID = "";
      this.MusteriPersonel.KapatAc = false;
      this.MusteriPersonel.SirketKodu = credentials.SirketKodu;

      
      this.$http.post(auth.API_URL + "api/Extra/CustomerPersonnelAdd", this.MusteriPersonel, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() },
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = this.$t("Update-completed");
          this.snackbar = true;
          this.dialog = false;
          setTimeout(() => {
  window.location.reload();
}, 500); 

          this.$http.post(auth.API_URL + "api/Extra/CustomerPersonnelList", {
            SirketKodu: credentials.SirketKodu,
            CariKod: this.$route.params.code,
          }, {
            headers: { Authorization: "Bearer " + auth.getAuthHeader() },
          }).then((response) => {
            this.items = response.body;
          });
        }
      });
    });
  });
}


</script>

<style>
</style>


<!-- <template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">
                            <cariaracomp tabindex="1" v-bind:etiket="$t('Select-Current-Account')" v-bind:value="MusteriPersonel.Cari.Kod" v-bind:renk="color" :loading="loading" 
                                  v-model="MusteriPersonel.Cari.Kod"></cariaracomp>

                      </div>
                      <div class="flex md6">
                        <div v-show="codegorunum === true ">
                          <v-text-field :label="this.$t('Company-Code')" tabindex="2" :color="color" hide-details=""
                            v-model="MusteriPersonel.SirketAdi" :error-messages="errors.collect('bankakod')"
                            v-validate="'required'" data-vv-name="bankakod" required>
                          </v-text-field>
                        </div>

                        <v-text-field :label="$t('Expense-Center')" :color="color" tabindex="3" hide-details=""
                          v-model="MusteriPersonel.MasrafYeri" :error-messages="errors.collect('bankaadi')"
                          v-validate="'required'" data-vv-name="bankaadi" required>
                        </v-text-field>
                        <v-text-field :label="$t('Registry-No')" hide-details="" v-model="MusteriPersonel.SicilNo" :color="color">
                        </v-text-field>
                        <v-text-field :label="$t('Name_label')" hide-details="" :color="color" v-model="MusteriPersonel.Adi">
                        </v-text-field>
                        <v-text-field :label="$t('Surname_label')" hide-details="" v-model="MusteriPersonel.Soyadi" :color="color">
                        </v-text-field>
                        <v-text-field :label="$t('Workplace')" hide-details="" v-model="MusteriPersonel.CalismaYeri"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('Department')" hide-details="" v-model="MusteriPersonel.Bolum" :color="color">
                        </v-text-field>
                      </div>

                      <div class="flex md6" style="padding-left:2px;">
                        <v-text-field :label="$t('Domestic-Travel')" hide-details="" v-model="MusteriPersonel.IcSeyahat"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('International-Travel')" hide-details="" v-model="MusteriPersonel.DisSeyahat"
                          :color="color"></v-text-field>
                        <v-text-field :label="$t('Business-Area')" hide-details="" :color="color" v-model="MusteriPersonel.IsAlani">
                        </v-text-field>
                        <v-text-field :label="$t('Order')" hide-details="" :color="color" v-model="MusteriPersonel.Siparis">
                        </v-text-field>
                        <v-text-field :label="$t('Email_label')" hide-details="" :color="color" v-model="MusteriPersonel.Email">
                        </v-text-field>
                        <v-text-field :label="$t('Telephone')" hide-details="" :color="color" v-model="MusteriPersonel.Tel">
                        </v-text-field>
                      </div>

                      <div class="flex md12">

                        <v-checkbox disabled="" :label="$t('Customer-Staff-Open')" v-model="MusteriPersonel.KapatAc">
                        </v-checkbox>

                      </div>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">




              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="musteriackapa()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Client-Personnel-Turn-on-and-off') }} </span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update"> {{ $t('Client-Personnel-Turn-on-and-off') }} </span>
              </v-tooltip>


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>



            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>



            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title class="baslikfont">{{ $t('Customer-Personnel-Information') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>




              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t('Add-Customer-Personnel')}}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t('Add-Customer-Personnel')}}</span>
              </v-tooltip>





      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.ID)" item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.SirketAdi }}</td>
            <td class="text-xs-left">{{ props.item.MasrafYeri }}</td>
            <td class="text-xs-left">{{ props.item.SicilNo }}</td>
            <td class="text-xs-left">{{ props.item.Adi }}</td>
            <td class="text-xs-left">{{ props.item.Soyadi }}</td>
            <td class="text-xs-left">{{ props.item.CalismaYeri }}</td>
            <td class="text-xs-left">{{ props.item.Bolum }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'ID',
            value: 'ID'
          },

          {
            text: this.$t('Company-Name'),
            value: 'SirketAdi'
          },
          {
            text: this.$t('Expense-Center'),
            value: 'MasrafYeri'
          },
          {
            text: this.$t('Registry-No'),
            value: 'SicilNo'
          },
          {
            text: this.$t('Name_label'),
            value: 'Adi'
          },
          {
            text: this.$t('Surname_label'),
            value: 'Soyadi'
          },
          {
            text: this.$t('Workplace'),
            value: 'CalismaYeri'
          },
          {
            text: this.$t('Department'),
            value: 'Bolum'
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,

        MusteriPersonel: {
          ID: '',
          SirketKodu: '',
          SirketAdi: '',
          MasrafYeri: '',
          SicilNo: '',
          Adi: '',
          Soyadi: '',
          CalismaYeri: '',
          Bolum: '',
          IcSeyahat: '',
          DisSeyahat: '',
          IsAlani: '',
          Siparis: '',
          Cari: {
            Kod: ''
          },
          KapatAc: false,
          Email: '',
          Tel: '',
        },




        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          SirketKodu: credentials.SirketKodu
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Müşteri Personel Bilgileri Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          CustomerPersonnelID: v

        }
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var seciliitems = [{
            autoText: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
            unvan1: response.body.Cari.Unvan + '-' + response.body.Cari.Kod,
            id: response.body.Cari.Kod
          }]
          this.state = seciliitems
          this.MusteriPersonel.Cari.Kod = response.body.Cari.Kod



          this.MusteriPersonel = response.body

        })
      },
      musteriackapa: musteriackapa,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      cariaracomp
    },
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu

        var params = this.MusteriPersonel

        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }

  function ekle() {

    this.MusteriPersonel.ID = ''
    this.MusteriPersonel.SirketKodu = ''
    this.MusteriPersonel.SirketAdi = ''
    this.MusteriPersonel.MasrafYeri = ''
    this.MusteriPersonel.SicilNo = ''
    this.MusteriPersonel.Adi = ''
    this.MusteriPersonel.Soyadi = ''
    this.MusteriPersonel.CalismaYeri = ''
    this.MusteriPersonel.Bolum = ''
    this.MusteriPersonel.IcSeyahat = ''
    this.MusteriPersonel.DisSeyahat = ''
    this.MusteriPersonel.IsAlani = ''
    this.MusteriPersonel.Siparis = ''
    this.MusteriPersonel.Cari.Kod = ''
    this.MusteriPersonel.KapatAc = false
    this.MusteriPersonel.Email = ''
    this.MusteriPersonel.Tel = ''

    this.dialog = true
    this.dialog_baslik = this.$t('Customer-Personnel')
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function musteriackapa() {
    if (window.confirm('Müşter/Personel\'i açmak veya kapatmak istediğinize eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.MusteriPersonel.SirketKodu = credentials.SirketKodu
      var params = {
        CustomerPersonnelID: this.MusteriPersonel.ID,
        CloseOpen: !(this.MusteriPersonel.KapatAc)
      }



      this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelCloseOpen', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          var params1 = {
            SirketKodu: credentials.SirketKodu
          }
          this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu
        var params = this.MusteriPersonel


        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            var params1 = {
              SirketKodu: credentials.SirketKodu
            }


            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style> -->